import { URLS } from 'services/urls';
import NSCarousel from 'bricks/NSCarousel/NSCarousel';
import './DirectSignUpPage.scss';

const featureCards = [
    {
        image: 'deal/signup/manage.png',
        alt: 'Manage',
        title: 'Manage your deal pipeline',
        description: 'Track, manage, and report on opportunities.',
    },
    {
        image: 'deal/signup/assess.png',
        alt: 'Assess',
        title: 'Assess financial feasibility',
        description: 'Evaluate quick, back-of-envelope scenarios for deals.',
    },
    {
        image: 'deal/signup/underwrite.png',
        alt: 'Underwrite',
        title: 'Underwrite deals',
        description: 'Model cash flows, returns, and profit distributions.',
    },
    {
        image: 'deal/signup/managepartner.png',
        alt: 'Manage Partner',
        title: 'Manage partner relations',
        description: 'Generate partner reports and automatically index deal-related communications.',
    },
];

interface IFeaturesSectionProps {
    mobileOnly?: boolean;
}

export const FeaturesSection = ({ mobileOnly = false }: IFeaturesSectionProps) => {
    // Mobile version - blue cards carousel above email input
    if (mobileOnly) {
        return (
            <div className="DirectSignUp__Features DirectSignUp__Features--mobile">
                <NSCarousel id="features-carousel">
                    {featureCards.map(card => (
                        <div key={card.image} className="DirectSignUp__FeatureWrapper DirectSignUp__FeatureWrapper--mobile">
                            <div className="DirectSignUp__Feature">
                                <img src={URLS.IMAGE_CLOUDFRONT_URL(card.image)} alt={card.alt} />
                                <div>
                                    <h4>{card.title}</h4>
                                    <p>{card.description}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </NSCarousel>
            </div>
        );
    }

    // Desktop version - stacked cards with blue background on right side of page
    return (
        <div className="DirectSignUp__Features DirectSignUp__Features--desktop">
            <img
                className="DirectSignUp__FeaturesImage"
                src={URLS.IMAGE_CLOUDFRONT_URL('deal/signup/building_side_image.png')}
                alt="Features Background"
            />
            {featureCards.map(card => (
                <div key={card.image} className="DirectSignUp__FeatureWrapper">
                    <div className="DirectSignUp__Feature">
                        <img src={URLS.IMAGE_CLOUDFRONT_URL(card.image)} alt={card.alt} />
                        <div>
                            <h4>{card.title}</h4>
                            <p>{card.description}</p>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default FeaturesSection;
